
import { defineComponent } from 'vue'
import accordionComponent from '@/components/accordion.components.vue'
import inputRange from '@/components/input_range.components.vue'
import checkBox from '@/components/input_checkbox.components.vue'
import checkboxColor from '@/components/input_checkbox_color.components.vue'
import recherchevehicule from "@/services/recherche_page.services"
import jsonFileFr from "@/library/languages/fr.json"
import jsonFileEn from "@/library/languages/en.json"


export default defineComponent({
  name: 'FilterDisplay',
  components: {
    accordionComponent,
    inputRange,
    checkBox,
    checkboxColor
  },
  setup() {
    const {
      state,
      isLocaleEN,
      isLocaleFR,
      changePage,
      refreshFilter,
      resetFilter,
      putDataInArray,
      ucFirst,
      ucFirstLowerCase,
      stringifyName,
      uniqueNames,
      newChecboxFilterSelected,
      newInputRangeSelected,
      openFilter,
      switchCards,
      changePageWaiting,
      changePageFilter,
      changePageSlider
    } = recherchevehicule;
    return {
      state,
      isLocaleEN,
      isLocaleFR,
      changePage,
      refreshFilter,
      resetFilter,
      putDataInArray,
      ucFirst,
      ucFirstLowerCase,
      stringifyName,
      uniqueNames,
      newChecboxFilterSelected,
      newInputRangeSelected,
      openFilter,
      switchCards,
      changePageWaiting,
      changePageFilter,
      changePageSlider
    }
  },
  created: function(){
    if(this.isLocaleEN()){
      this.state.locale = 'en';
      this.state.jsonFile = jsonFileEn;
    }
    else{
      this.state.locale = 'fr';
      this.state.jsonFile = jsonFileFr;
    }
  }
})
